import generateRouter from '@ms/plugins/router.js'
import { stringifyQuery, parseQuery } from '@ms/utils/router/query.js'
import { useAuthStore } from '@ms/stores/auth'
import { prefixLink } from '@ms/config/app'
import updateTitle from '@ms/routes/title'
import i18n from '@ms/lang/i18n.js'
import routesMatches from './matches.js'
import routesJackpot from './jackpot.js'
import Home from 'wap/views/index/App.vue'
import routesOrders from './order.js'
import routesTrades from './trade.js'
import routesGames from './games.js'
import routesCodeTalk from './code-talk.js'
import routerMyMatches from './myMatches.js'
import routerAccount from './account'
import { useLayoutStore } from 'wap/stores/layout'
import { useThemeRouteFilter } from 'composables/useThemeRouteFilter.js'

// const Home = () => import(/* webpackPrefetch: true, webpackChunkName: 'home' */ 'wap/views/index/App.vue')

const routes = [
  ...routesMatches,
  ...routesJackpot,
  ...routesOrders,
  ...routesTrades,
  ...routesGames,
  ...routesCodeTalk,
  ...routerMyMatches,
  ...routerAccount,
  {
    path: '/messages',
    name: 'messages',
    component: () => import(/* webpackChunkName: 'message' */ 'wap/views/message/App.vue'),
    meta: {
      source: 'Message',
      title: 'Messages | MSport'
    }
  },
  {
    path: '/posts',
    name: 'post',
    component: () => import(/* webpackChunkName: 'message' */ 'wap/views/post/App.vue'),
    meta: {
      source: 'Post',
      hideHeader: true,
      title: 'Posts | MSport'
    }
  },
  {
    path: '/edit_stake',
    name: 'editStake',
    component: () => import(/* webpackPrefetch: true, webpackChunkName: 'edit_stake' */ 'wap/views/editStake/App.vue'),
    meta: {
      hideHeader: true,
      title: 'MSport | Quick Stake',
      enableTheme: true
    }
  },
  {
    path: '*',
    name: 'home',
    component: Home,
    meta: {
      source: 'Home',
      requiresDownload: true,
      requiresNotice: true,
      requiresTopBubble: true,
      requiresBroadcast: true,
      requiresFirstNavs: true,
      requiresBetslip: true,
      showNewTag: true,
      title: process.env.VUE_APP_DEFAULT_TITLE.replace('xxxxx', i18n.t('COUNTRY_NAME')),
      enableTheme: true
    }
  }
]

const router = generateRouter(routes, {
  base: prefixLink(),
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.savedPosition !== false && savedPosition) {
      return savedPosition
    }
    const { hash } = to
    if (hash && !/=/.test(hash)) {
      return {
        selector: hash
      }
    }
    if (to.name !== from.name) {
      return { y: 0 }
    }
  },
  stringifyQuery,
  parseQuery
})

// 标记 router 类型
router.__type__ = 'main'

// 第一次加载完页面 chunk, 比如刷新当前页
let chunkLoaded = false

router.beforeEach((to, _from, next) => {
  if (!useAuthStore().loginStatus) {
    useAuthStore().autoCheck()
  }

  if (!chunkLoaded) {
    useLayoutStore().toggleLoading(true)
  }

  useThemeRouteFilter(to)

  next()
})

router.afterEach((to) => {
  updateTitle(to)
  if (!chunkLoaded) {
    useLayoutStore().toggleLoading(false)
    chunkLoaded = true
  }
})

export default router
